import React from 'react';

const getMaskedNumber = n => {
  // console.log('getMaskedNumber');
  let numero;

  n = n?.replace(/\./g, '').replace(/\-/g, '');

  if (n) {
    numero = parseInt(n, 10);
    numero = numero.toString();
    // console.log({ n, numero });
  } else {
    numero = n;
  }

  const length = numero?.length;

  if (length) {
    const numeros = Array.from(numero);
    let nuevos = numeros;

    if (length > 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      const part0 = numeros.slice(0, length - 7);
      nuevos = [...part0, '.', ...part1, '.', ...part2, '-', ...part3];
    } else if (length === 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      nuevos = [...part1, '.', ...part2, '-', ...part3];
    } else if (length === 6) {
      const part2 = numeros.slice(length - 3, length);
      const part1 = numeros.slice(length - 6, length - 3);
      nuevos = [...part1, '.', ...part2];
    }

    return nuevos.join('');
  } else {
    return numero;
  }
};

const Referrer = ({ documentType, documentNumber }) => (
  <div className="referrer">
    <svg width={22} height={13} fill="none" viewBox="0 0 22 13">
      <path
        d="M5 3.5c0 .688-.25 1.281-.75 1.781a2.394 2.394 0 01-1.758.727A2.394 2.394 0 01.734 5.28 2.473 2.473 0 01.008 3.5c0-.688.242-1.273.726-1.758.485-.5 1.07-.75 1.758-.75s1.274.25 1.758.75c.5.485.75 1.07.75 1.758zM10.508.992c-.688 0-1.281.25-1.781.75A2.394 2.394 0 008 3.5c0 .688.242 1.281.727 1.781.5.485 1.093.727 1.78.727.688 0 1.274-.242 1.759-.727.484-.5.726-1.093.726-1.781s-.242-1.273-.726-1.758c-.485-.5-1.07-.75-1.758-.75zm7.992 0c-.688 0-1.281.25-1.781.75a2.394 2.394 0 00-.727 1.758c0 .688.242 1.281.727 1.781.5.485 1.093.727 1.781.727s1.273-.242 1.758-.727c.5-.5.75-1.093.75-1.781s-.25-1.273-.75-1.758c-.485-.5-1.07-.75-1.758-.75zM2.492 8c-.687 0-1.273.25-1.758.75a2.394 2.394 0 00-.726 1.758c0 .687.242 1.273.726 1.758.485.484 1.07.726 1.758.726s1.274-.242 1.758-.726c.5-.485.75-1.07.75-1.758s-.25-1.274-.75-1.758C3.766 8.25 3.18 8 2.492 8zm8.016 0c-.688 0-1.281.25-1.781.75A2.394 2.394 0 008 10.508c0 .687.242 1.273.727 1.758.5.484 1.093.726 1.78.726.688 0 1.274-.242 1.759-.726.484-.485.726-1.07.726-1.758s-.242-1.274-.726-1.758c-.485-.5-1.07-.75-1.758-.75zm9.984 1.992h-1.5v-1.5a.45.45 0 00-.14-.328A.444.444 0 0018.5 8a.444.444 0 00-.352.164.45.45 0 00-.14.328v1.5h-1.5a.517.517 0 00-.375.164.477.477 0 00-.14.352c0 .125.046.242.14.351a.56.56 0 00.375.141h1.5v1.5a.477.477 0 00.492.492.477.477 0 00.492-.492V11h1.5c.14 0 .258-.047.352-.14a.493.493 0 00.164-.352.444.444 0 00-.164-.352.444.444 0 00-.352-.164z"
        fill="#FF6200"
      />
    </svg>

    <div>
      <div className="referrer-label">Documento de quien te recomendó Itaú</div>
      <div className="referrer-value">
        {documentType == 1 ? getMaskedNumber(documentNumber) : documentNumber}
      </div>
    </div>

    <style jsx>{`
      .referrer {
        display: flex;
        background: #fff;
        box-shadow: 0px 0px 3px rgba(16, 25, 32, 0.05), 0px 2px 4px rgba(6, 21, 33, 0.05);
        border-radius: 4px;
        padding: 12px 20px;
        align-items: center;
        margin-top: 32px;
      }

      svg {
        margin-right: 16px;
      }

      .referrer-label {
        font-weight: bold;
        font-size: 14px;
        color: #89837f;
      }

      .referrer-value {
        font-weight: normal;
        font-size: 16px;
        color: #56504c;
      }
    `}</style>
  </div>
);

export default Referrer;
